import Button from "@material-ui/core/Button";
import { ValidatorForm } from "react-material-ui-form-validator";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import React, { Component } from "react";
class PtsConfirmDialogue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      title: props.title,
      text: props.text,
      confirmCallback: props.confirmCallback,
      notConfirmCallback: props.notConfirmCallback,
      pageId: this.props.pageId,
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleConfirmYes = () => {
    if (this.state.confirmCallback) {
      this.state.confirmCallback();
    } else if (this.props.confirmCallback) {
      this.props.confirmCallback();
    }
    this.setState({ open: false });
  };

  handleClose() {
    this.setState({ open: false });
  }

  showDeleteMessage() {
    if (this.state.pageId === "ActivityContact") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              Click CONFIRM to remove the number from this activity report list.<br></br>
              Doing so will not remove the number from the opt-in list.
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "Contact") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            {this.state.text === "OptIn" && (
              <p className="m-0" style={{ fontSize: "16px" }}>
                Deleting contacts from the Opt-in List, will also delete them from ALL groups/lists.
              </p>
            )}
            {this.state.text === "InActive" && (
              <p className="m-0" style={{ fontSize: "16px" }}>
                The contact will be removed from pending list.
              </p>
            )}
            {this.state.text === "OptOut" && (
              <p className="m-0" style={{ fontSize: "16px" }}>
                The contact will be removed from opt-out list.
              </p>
            )}
            {this.state.text === "InvalidNumber" && (
              <p className="m-0" style={{ fontSize: "16px" }}>
                The contact will be removed from failed number list.
              </p>
            )}
          </span>
        </>
      );
    } else if (this.state.pageId === "contactGroup") {
      return (
        <>
          <p className="m-0" style={{ fontSize: "16px" }}>
            Click CONFIRM to remove the mobile number from this group.
            <br></br>
            (It will not be removed from other locations).
          </p>
        </>
      );
    } else if (this.state.pageId === "UseCase") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              Are you sure about deleting this Use Case?
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "scheduledSend") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              This Scheduled Send record will be deleted from this page.
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "scheduledCancelled") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              Click Delete to cancel this Scheduled Send.
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "sendHistory") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              This Send History will be deleted.
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "Recipient") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              Click CONFIRM to remove the mobile number from this list. (It will
              not be removed from other locations).
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "MessageTemplate") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              You are deleting the message template{" "}
              <span
                style={{
                  color: " #37517e",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                “{this.props.text}”.
              </span>
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "shortLink") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              You want to remove this link from your list of shortlinks?
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "cardDelete") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              This card details will be deleted.
            </p>
          </span>
        </>
      );
    } else if (this.state.pageId === "Group") {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              You are about to delete the group {this.props.text} and any pending numbers it contains.
            </p>
              <p className="m-0" style={{ fontSize: "16px" }}>
              Deleting a group does NOT delete opted-in numbers from the account.
            </p>
          </span>
        </>
      );
    } else {
      return (
        <>
          <span style={{ textAlign: "start" }}>
            <p className="m-0" style={{ fontSize: "16px" }}>
              You are about to permanently delete the{" "}
              <span style={{ textTransform: "lowercase" }}>
                {this.state.pageId}
              </span>{" "}
              <span
                style={{
                  color: " #37517e",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                “{this.props.text}”.
              </span>
            </p>
          </span>
        </>
      );
    }
  }

  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        style={{ padding: "1em" }}
        className="ptsConfirmDialogue"
      >
        <DialogContent>{this.showDeleteMessage()}</DialogContent>
        <ValidatorForm
          className="text-start"
          ref="form"
          onSubmit={this.handleConfirmYes.bind(this)}
        >
          <DialogActions
            style={{
              // marginTop: "1em",
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
              justifyContent: "center",
            }}
          >
            {this.state.pageId === "scheduledCancelled" ?
              <Button
                variant="contained"
                type="submit"
                size="large"
                autoFocus
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
              // onClick={this.handleConfirmYes.bind(this)}
              >
                Delete
              </Button>
              :
              <>
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  autoFocus
                  style={{
                    background: "#37517e",
                    color: "#fff",
                    marginRight: "1rem",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<SaveIcon />}
                // onClick={this.handleConfirmYes.bind(this)}
                >
                  Confirm
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  type="button"
                  style={{
                    background: "#717373",
                    color: "#fff",
                    marginRight: "1rem",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<CloseIcon />}
                  onClick={this.handleClose.bind(this)}
                >
                  Cancel
                </Button>
              </>
            }
          </DialogActions>
        </ValidatorForm>
      </Dialog>
    );
  }
}

export default PtsConfirmDialogue;
